import { useParams } from "react-router-dom";
import React, { useEffect, useRef, useState, useCallback } from "react";
import datafeed from "./datafeed";
import { fetchPSXSymbols } from "./helpers";

const TradingViewChart = () => {
  const chartRef    = useRef(null);
  const widgetRef   = useRef(null);

  const { symbol } = useParams();
  const [symbols,        setSymbols]        = useState([]);
  const [selectedSymbol, setSelectedSymbol] = useState(null); // { code, name }
  const [query,          setQuery]          = useState("");
  const [showDropdown,   setShowDropdown]   = useState(false);
  const [loadingSymbols, setLoadingSymbols] = useState(true);
  const dropdownRef = useRef();

  // ── fetch PSX symbol list once ───────────────────────────────────────────
  useEffect(() => {
    fetchPSXSymbols()
      .then(list => {
        setSymbols(list);
              const urlSymbol = symbol?.toUpperCase();

        const matchedSymbol = list.find(
          (s) => s.code?.toUpperCase() === urlSymbol
        );

        if (matchedSymbol) {
          setSelectedSymbol(matchedSymbol);
        } else if (list.length > 0) {
          setSelectedSymbol(list[0]);
        }
      })
      .catch(() => {})
      .finally(() => setLoadingSymbols(false));
  }, [symbol]); // eslint-disable-line
       

  // ── mount / re-mount TradingView widget when symbol changes ──────────────
  useEffect(() => {
    if (!selectedSymbol) return;
    if (!window.TradingView) {
      console.error("TradingView charting library not loaded");
      return;
    }

    // destroy previous widget
    if (widgetRef.current) {
      try { widgetRef.current.remove(); } catch (_) {}
      widgetRef.current = null;
    }

    widgetRef.current = new window.TradingView.widget({
      container:    chartRef.current,
      locale:       "en",
      library_path: "/charting_library/",
      datafeed,
      symbol:       `PSX:${selectedSymbol.code}`,
      interval:     "1D",
      fullscreen:   false,
      autosize:     true,
      timezone:     "Asia/Karachi",
      theme:        "light",
      debug:        false,
      // allow built-in symbol search (uses datafeed.searchSymbols)
      disabled_features: [],
      enabled_features:  ["hide_left_toolbar_by_default"],
    });

    return () => {
      if (widgetRef.current) {
        try { widgetRef.current.remove(); } catch (_) {}
        widgetRef.current = null;
      }
    };
  }, [selectedSymbol]);

  // ── close dropdown on outside click ─────────────────────────────────────
  useEffect(() => {
    function handle(e) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target))
        setShowDropdown(false);
    }
    document.addEventListener("mousedown", handle);
    return () => document.removeEventListener("mousedown", handle);
  }, []);

  const filtered = query.trim()
    ? symbols.filter(s =>
        s.code?.toLowerCase().includes(query.toLowerCase()) ||
        s.name?.toLowerCase().includes(query.toLowerCase())
      )
    : symbols;

  const pickSymbol = useCallback((sym) => {
    setSelectedSymbol(sym);
    setQuery("");
    setShowDropdown(false);
  }, []);

  // ── styles ───────────────────────────────────────────────────────────────
  const toolbarStyle = {
    display: "flex", alignItems: "center", gap: 12,
    padding: "10px 16px", background: "#fff",
    borderBottom: "1px solid #e5e7eb", flexShrink: 0,
  };
  const inputWrapStyle = {
    display: "flex", alignItems: "center",
    border: "1px solid #e5e7eb", borderRadius: 8,
    overflow: "hidden", background: "#fff",
  };
  const dropdownStyle = {
    position: "absolute", top: "calc(100% + 4px)", right: 0,
    background: "#fff", border: "1px solid #e5e7eb", borderRadius: 10,
    boxShadow: "0 8px 24px rgba(0,0,0,0.10)",
    maxHeight: 280, overflowY: "auto", zIndex: 9999, minWidth: 230,
  };

  return (
      <div
    style={{
      width: "100%",
      height: "100%",
      minHeight: 0,
      flex: 1,
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
      margin: 0,
      padding: 0,
    }}
  >
    <div
      ref={chartRef}
      style={{
        width: "100%",
        height: "100%",
        flex: 1,
        minHeight: 0,
        padding: 0,
        margin: 0,
      }}
    />
  </div>

  );
};

export default TradingViewChart;
